import { READY_TO_CARGO } from "@/app/infrastructures/misc/RolePermission";

import CargoModules from "./cargo";
import CargoV2Routes from "./cargo-v2";
import { flags } from "@/feature-flags";
import { FlagsPermissionCargo } from "@/feature-flags/flags-permission-cargo";
import { FlagsPermissionCargoV2 } from "@/feature-flags/flags-permission-cargo-v2";

const Layout = () =>
  import(/* webpackChunkName: "Layout" */ "@/app/ui/layout/index.vue");

// Cargo
const Cargo = () =>
  import(/* webpackChunkName: "Cargo" */ "@/app/ui/views/cargo/index.vue");
const TabReadyToCargo = () =>
  import(
    /* webpackChunkName: "RTCargo" */ "@/app/ui/views/cargo/ready-to-cargo/tab-ready-to-cargo.vue"
  );
const TabProcessReadyToCargo = () =>
  import(
    /* webpackChunkName: "RTCargo" */ "@/app/ui/views/cargo/ready-to-cargo/tab-process-ready-to-cargo.vue"
  );
const ReadyToCargo = () =>
  import(
    /* webpackChunkName: "RTCargo" */ "@/app/ui/views/cargo/ready-to-cargo/index.vue"
  );

const bookingSuccess = () =>
  import(
    /* webpackChunkName: "Cargo" */ "@/app/ui/views/cargo/tab-booking-success.vue"
  );
const bookingInProgress = () =>
  import(
    /* webpackChunkName: "Cargo" */ "@/app/ui/views/cargo/tab-booking-in-progress.vue"
  );
const bookingCanceled = () =>
  import(
    /* webpackChunkName: "Cargo" */ "@/app/ui/views/cargo/tab-booking-canceled.vue"
  );
const CargoV2Index = () =>
  import(/* webpackChunkName: "CargoV2" */ "@/app/ui/views/cargo-v2/index.vue");
const CargoV2BookingSuccess = () =>
  import(
    /* webpackChunkName: "CargoV2" */ "@/app/ui/views/cargo-v2/tab-booking-success.vue"
  );
const CargoV2BookingInProgress = () =>
  import(
    /* webpackChunkName: "CargoV2" */ "@/app/ui/views/cargo-v2/tab-booking-in-progress.vue"
  );
const CargoV2BookingCancelled = () =>
  import(
    /* webpackChunkName: "CargoV2" */ "@/app/ui/views/cargo-v2/tab-booking-cancelled.vue"
  );

export default [
  {
    path: "",
    redirect: "/dashboard",
    component: Layout,
    name: "cargo",
    meta: {
      header: true,
      children: true,
      icon: "cargo",
      title: "Kargo - Booking Kargo",
      name: "Kargo",
      permission: [
        FlagsPermissionCargo.permission_cargo_enable,
        READY_TO_CARGO.ENABLE
      ],
      noPaddingWithBreadcrumbV2: true,
      newLayout: true
    },
    children: [
      {
        path: "cargo",
        name: "booking-cargo",
        redirect: "/cargo/booking-success",
        component: Cargo,
        meta: {
          header: true,
          noPaddingWithBreadcrumbV2: true,
          name: "Booking Kargo",
          icon: "booking-cargo",
          permission: [
            FlagsPermissionCargo.permission_cargo_enable,
            flags.permission_single_menu_cargo_enable
          ]
        },
        children: [
          {
            path: "booking-success",
            name: "booking-success",
            component: bookingSuccess,
            meta: {
              header: true
            }
          },
          {
            path: "booking-in-progress",
            name: "booking-in-progress",
            component: bookingInProgress,
            meta: {
              header: true
            }
          },
          {
            path: "booking-canceled",
            name: "booking-canceled",
            component: bookingCanceled,
            meta: {
              header: true
            }
          }
        ]
      },
      {
        path: "cargo-v2",
        name: "cargo-v2",
        redirect: "/cargo-v2/booking-success",
        component: CargoV2Index,
        meta: {
          header: true,
          noPaddingWithBreadcrumbV2: true,
          name: "Daftar CARGO",
          icon: "booking-cargo",
          permission: [
            FlagsPermissionCargoV2.permission_cargo_v2_enable,
            FlagsPermissionCargoV2.permission_cargo_v2_booking_list,
            flags.permission_single_menu_cargo_enable
          ]
        },
        children: [
          {
            path: "booking-success",
            name: "cargo-v2-booking-success",
            component: CargoV2BookingSuccess,
            meta: { header: true }
          },
          {
            path: "booking-in-progress",
            name: "cargo-v2-booking-in-progress",
            component: CargoV2BookingInProgress,
            meta: { header: true }
          },
          {
            path: "booking-cancelled",
            name: "cargo-v2-booking-cancelled",
            component: CargoV2BookingCancelled,
            meta: { header: true }
          }
        ]
      },
      {
        path: "siap-kargo",
        name: "siap-kargo",
        redirect: "/siap-kargo/proses-siap-kargo",
        component: ReadyToCargo,
        meta: {
          header: true,
          name: "Siap DiKargo",
          icon: "ready-to-cargo",
          permission: READY_TO_CARGO.LIST
        },
        children: [
          {
            path: "proses-siap-kargo",
            name: "proses-siap-kargo",
            component: TabProcessReadyToCargo,
            meta: {
              header: true
            }
          },
          {
            path: "list-siap-kargo",
            name: "list-siap-kargo",
            component: TabReadyToCargo,
            meta: {
              header: true
            }
          }
        ]
      }
    ]
  },
  ...CargoModules,
  ...CargoV2Routes
];
